enum CacheConfig {
  DEFAULT_TTL = 300000,
}

export { CacheConfig };
